import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useTabPages } from '@ts-core/hooks/ui';

import AttendanceManagementPage from 'modules/attendance/pages/AttendanceManagementPage';
import AttendanceStatsPage from 'modules/attendance/pages/AttendanceStatsPage';

export default function useAttendanceTabPage() {
  const intl = useIntl();

  const pages = useMemo(
    () => [
      {
        Component: AttendanceManagementPage,
        tab: {
          label: intl.formatMessage({
            id: 'attendancePage.tab.attendanceManagement',
          }),
          slug: 'management',
        },
      },
      {
        Component: AttendanceStatsPage,
        tab: {
          label: intl.formatMessage({
            id: 'attendancePage.tab.attendanceStats',
          }),
          slug: 'stats',
        },
      },
    ],
    [intl]
  );

  return useTabPages({ pages, slugParam: 'tab' });
}
